/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_viewer = {
    readonly isAboutTheMakerEnabled?: boolean | null;
    readonly isFavoritesEnabled?: boolean | null;
    readonly disablePdpExitModal?: boolean | null;
    readonly disableConsumerSourcingModal?: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_viewer" | "PdpRespShippingReturns_viewer" | "PdpRespIconBubblesWrapper_viewer" | "PdpRespSimilarItemsFooter_viewer" | "PdpRespSimilarItemsGridSeller_viewer" | "PdpRespHeroCarousel_viewer" | "PdpRespSeoLinks_viewer" | "PdpRespDealerDetails_viewer" | "PdpRespSidebarContact_viewer" | "PdpRespSidebarSellerInfo_viewer" | "SuspectedTradeUserLoader_viewer" | "PdpSharedShippingBadge_viewer" | "PdpSharedShippingDetails_viewer">;
    readonly " $refType": "PdpRespContainer_viewer";
};
export type PdpRespContainer_viewer$data = PdpRespContainer_viewer;
export type PdpRespContainer_viewer$key = {
    readonly " $data"?: PdpRespContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "isAboutTheMakerEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "ABOUT_THE_MAKER"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"ABOUT_THE_MAKER\")"
        },
        {
          "kind": "ScalarField",
          "alias": "isFavoritesEnabled",
          "name": "isEnabledByLocale",
          "args": [
            {
              "kind": "Literal",
              "name": "featureName",
              "value": "FAVORITES"
            }
          ],
          "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
        },
        {
          "kind": "ScalarField",
          "alias": "disablePdpExitModal",
          "name": "isEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disablePdpExitModal"
            }
          ],
          "storageKey": "isEnabled(key:\"disablePdpExitModal\")"
        },
        {
          "kind": "ScalarField",
          "alias": "disableConsumerSourcingModal",
          "name": "isEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableConsumerSourcingModal"
            }
          ],
          "storageKey": "isEnabled(key:\"disableConsumerSourcingModal\")"
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSeoLinks_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingDetails_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '8455db956a553862c71eb394faf8b804';
export default node;
